import React from 'react';
import { Link } from 'raviger';
import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import Moment from 'react-moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckSquare,
  faSoap,
  faEye,
  faWater,
  faSyringe,
} from '@fortawesome/free-solid-svg-icons';
import {
  faRectangle,
  faSquareExclamation,
  faScalpelLineDashed,
} from '@fortawesome/pro-solid-svg-icons';
import { faBandage, faSpiral } from '@fortawesome/pro-regular-svg-icons';

function ProcedureCard(props) {

  return (
    <>
    <Row className="mb-3">
      <Col xs={10}>
      <Link href={"/" + props.organization + "/" + props.incident + "/vet/procedureresult/edit/" + props.procedure.id} className="treatment-link p-0" style={{textDecoration:"none", color:"white"}}>
        <Card className="border rounded treatment-hover-div" style={{height:props.animal_object ? "120px" : "100px"}}>
          <div className="row no-gutters hover-div treatment-hover-div ms-0" style={{height:"100px", marginRight:"-2px"}}>
            <Row className="ms-0 me-0 w-100 p-0" style={{flexWrap:"nowrap"}}>
              {props.animal_object ?
              <div className="border-end p-0" style={{height:props.animal_object ? "120px" : "100px", width:"120px"}}>
                {props.procedure.name.toLowerCase().includes('bandage') || props.procedure.other_name.toLowerCase().includes('bandage') || props.procedure.name.toLowerCase().includes('splint') || props.procedure.other_name.toLowerCase().includes('splint') ?
                  <FontAwesomeIcon icon={faBandage} size="6x" className="treatment-icon" style={{marginTop:"13px", marginLeft:"9px"}} transform={'shrink-1'} inverse />
                : props.procedure.name.toLowerCase().includes('hydro') || props.procedure.other_name.toLowerCase().includes('hydro') || props.procedure.name.toLowerCase().includes('water') || props.procedure.other_name.toLowerCase().includes('water') ?
                  <FontAwesomeIcon icon={faWater} size="6x" className="treatment-icon" style={{marginTop:"5px", marginLeft:"-1px"}} transform={'grow-1 right-3 down-2'} inverse />
                : props.procedure.name.toLowerCase().includes('eye') || props.procedure.other_name.toLowerCase().includes('eye') ?
                  <FontAwesomeIcon icon={faEye} size="6x" className="treatment-icon" style={{marginTop:"14px", marginLeft:"9px"}} transform={'grow-1'} inverse />
                : props.procedure.name.toLowerCase().includes('clean') || props.procedure.other_name.toLowerCase().includes('clean') ?
                  <FontAwesomeIcon icon={faSoap} size="6x" className="treatment-icon" style={{marginTop:"19px", marginLeft:"14px"}} transform={'grow-1'} inverse />
                : props.procedure.name.toLowerCase().includes('thoracocentesis') || props.procedure.other_name.toLowerCase().includes('clean') || props.procedure.other_name.toLowerCase().includes('needle') ?
                  <FontAwesomeIcon icon={faSyringe} size="6x" className="treatment-icon" style={{marginTop:"16px", marginLeft:"8px"}} transform={'grow-1'} inverse />
                : props.procedure.name.toLowerCase().includes('tube') || props.procedure.other_name.toLowerCase().includes('tube') ?
                  <span className="fa-layers" style={{marginLeft:"16px"}}>
                    <FontAwesomeIcon icon={faSpiral} size="6x" className="treatment-icon" transform={'down-8'} inverse />
                    <FontAwesomeIcon icon={faRectangle} size="2x" className="treatment-icon" transform={'shrink-6 rotate-132 down-3 right-3'} style={{marginBottom:"-9px"}} inverse />
                  </span>
                :
                  <FontAwesomeIcon icon={faScalpelLineDashed} size="6x" className="treatment-icon" style={{marginTop:"16px", marginLeft:"7px"}} inverse />
                }
              </div>
              :
              <div className="border-end p-0" style={{width:"100px"}}>
                {props.procedure.name.toLowerCase().includes('bandage') || props.procedure.other_name.toLowerCase().includes('bandage') || props.procedure.name.toLowerCase().includes('splint') || props.procedure.other_name.toLowerCase().includes('splint') ?
                  <FontAwesomeIcon icon={faBandage} size="5x" className="treatment-icon" style={{marginTop:"12px", marginLeft:"8px"}} transform={'shrink-1'} inverse />
                : props.procedure.name.toLowerCase().includes('hydro') || props.procedure.other_name.toLowerCase().includes('hydro') || props.procedure.name.toLowerCase().includes('water') || props.procedure.other_name.toLowerCase().includes('water') ?
                  <FontAwesomeIcon icon={faWater} size="5x" className="treatment-icon" style={{marginTop:"13px", marginLeft:"12px"}} transform={'grow-1'} inverse />
                : props.procedure.name.toLowerCase().includes('eye') || props.procedure.other_name.toLowerCase().includes('eye') ?
                  <FontAwesomeIcon icon={faEye} size="5x" className="treatment-icon" style={{marginTop:"13px", marginLeft:"8px"}} transform={'grow-1'} inverse />
                : props.procedure.name.toLowerCase().includes('clean') || props.procedure.other_name.toLowerCase().includes('clean') ?
                  <FontAwesomeIcon icon={faSoap} size="5x" className="treatment-icon" style={{marginTop:"16px", marginLeft:"12px"}} transform={'grow-2'} inverse />
                : props.procedure.name.toLowerCase().includes('thoracocentesis') || props.procedure.other_name.toLowerCase().includes('clean') || props.procedure.other_name.toLowerCase().includes('needle') ?
                  <FontAwesomeIcon icon={faSyringe} size="6x" className="treatment-icon" style={{marginTop:"5px", marginLeft:"0px"}} transform={'shrink-2'} inverse />
                : props.procedure.name.toLowerCase().includes('tube') || props.procedure.other_name.toLowerCase().includes('tube') ?
                  <span className="fa-layers" style={{marginLeft:"16px"}}>
                    <FontAwesomeIcon icon={faSpiral} size="4x" className="treatment-icon" transform={'down-10'} inverse />
                    <FontAwesomeIcon icon={faRectangle} size="1x" className="treatment-icon" transform={'shrink-5 rotate-137 down-10 right-10'} inverse />
                  </span>
                :
                  <FontAwesomeIcon icon={faScalpelLineDashed} size="5x" className="treatment-icon" style={{marginTop:"13px", marginLeft:"5px"}} inverse />
                }
              </div>
              }
              <Col className="hover-div ps-0 pe-0">
                <div className="border rounded treatment-hover-div" style={{paddingTop:"6px", paddingBottom:"7px", paddingLeft:"5px", marginLeft:"-1px", marginTop: "-1px", fontSize:"18px", width:"100%", backgroundColor:"rgb(158 153 153)"}}>
                  <span style={{marginLeft:"5px"}}>{props.procedure.other_name ? props.procedure.other_name : props.procedure.name}</span>
                  <span className="float-end">
                  {props.procedure.complete ?
                    <OverlayTrigger
                      key={"complete-procedures"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-complete-procedures`}>
                          Procedure order is complete.
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faCheckSquare} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                    </OverlayTrigger>
                    :
                    <OverlayTrigger
                      key={"scheduled-procedures"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-scheduled-procedures`}>
                          Procedure order is pending.
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faSquareExclamation} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                    </OverlayTrigger>
                    }
                  </span>
                </div>
                {props.animal_object ? <Row className="mt-1 ps-0 pe-0 ms-0 me-0 w-100">
                  <Col xs={4}>
                    <b>Patient: </b>A#{props.animal_object.id_for_incident}
                  </Col>
                  <Col xs={3}>
                    <b>Species:</b> <span  style={{textTransform:"capitalize"}}>{props.animal_object.species_string}</span>
                  </Col>
                  <Col xs={5}>
                    <b>Name: </b>{props.animal_object.name || "Unknown Name"}
                  </Col>
                </Row> : ""}
                <Row className="ps-0 pe-0 ms-0 me-0" style={{marginTop:props.animal_object ? "1px" : "6px"}}>
                  {props.procedure.complete ?
                  <Col xs={4}>
                    <b>Completed: </b><Moment format="MMM DD YYYY, HH:mm">{props.procedure.complete}</Moment>
                  </Col>
                  :
                  <Col xs={4}>
                    <b>Scheduled: </b><Moment format="MMM DD YYYY">{props.procedure.open}</Moment>
                  </Col>
                  }
                  <Col xs={4}>
                    <b>Performer: </b>{props.procedure.performer ? <span>{props.procedure.performer_object.first_name + ' ' + props.procedure.performer_object.last_name}</span> : 'N/A'}
                  </Col>
                  <Col xs={3}>
                    <b>Status: </b>{props.procedure.complete ? 'Complete' : 'Pending'}
                  </Col>
                </Row>
                <Row className="ps-0 pe-0 ms-0 me-0">
                  <Col style={{overflowX:"ellipsis"}}>
                    <b>Notes: </b>{props.procedure.notes || "N/A"}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Card>
      </Link>
      </Col>
    </Row>
  </>
  )
}

export default ProcedureCard;
